const actions = {
  GET_MDN_SWAP_REPORT_REQUEST_LIST: "GET_MDN_SWAP_REPORT_REQUEST_LIST",
  GET_MDN_SWAP_REPORT_REQUEST_LIST_SUCCESSFUL:
    "GET_MDN_SWAP_REPORT_REQUEST_LIST_SUCCESSFUL",
  GET_MDN_SWAP_REPORT_REQUEST_LIST_FAILED:
    "GET_MDN_SWAP_REPORT_REQUEST_LIST_FAILED",

  getMdnSwapReportRequestList: (searchData) => ({
    type: actions.GET_MDN_SWAP_REPORT_REQUEST_LIST,
    payload: { searchData },
  }),
  getMndSwapeportRequestListSuccessful: (data) => ({
    type: actions.GET_MDN_SWAP_REPORT_REQUEST_LIST_SUCCESSFUL,
    payload: { data },
  }),
  getMdnSwapReportRequestListFailed: (error) => ({
    type: actions.GET_MDN_SWAP_REPORT_REQUEST_LIST_FAILED,
    payload: { error },
  }),
};

export default actions;
